<ng-container *transloco="let t">
  <div class="flex items-center justify-center min-h-[calc(100vh-200px)] p-8 bg-gray-100">
    <div class="text-center max-w-md py-12 px-8 bg-white rounded-xl shadow-card">
      <div class="w-20 h-20 mx-auto mb-6 text-amber-500">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="w-full h-full"
        >
          <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
          <line x1="12" y1="9" x2="12" y2="13"></line>
          <line x1="12" y1="17" x2="12.01" y2="17"></line>
        </svg>
      </div>

      <h1 class="text-2xl font-semibold text-gray-800 mb-4">{{ title() }}</h1>

      <p class="text-base text-gray-500 leading-relaxed mb-6">{{ message() }}</p>

      @if (showContactInfo()) {
        <div class="p-4 ld-neutral-100 rounded-lg mb-8">
          <p class="text-sm text-gray-500 m-0">{{ t('authMaintenanceNeedAssistance') }}</p>
          <p class="text-sm font-medium mt-2 m-0">
            {{ t('commonPayoffQuoteCallUsAt') }}
            <a [href]="'tel:' + phoneNumber()" class="text-blue-600 hover:underline">{{ phoneNumber() }}</a>
          </p>
        </div>
      }

      <div class="flex flex-col sm:flex-row gap-3 justify-center">
        <button mat-flat-button color="primary" class="min-w-[140px]" (click)="onRefresh()">
          {{ t('authCookiesDisabledRefreshButton') }}
        </button>
        <button mat-stroked-button class="min-w-[140px]" (click)="onGoHome()">
          {{ t('errorsGoToDashboard') }}
        </button>
      </div>
    </div>
  </div>
</ng-container>
